import { createSlice } from '@reduxjs/toolkit';

const addSignerSlice = createSlice({
  name: "addSigner",
  initialState: { addSignerData: [] },
  reducers: {
    addSigner(state, action) {
      const { payload } = action;
      return { ...state, addSignerData: payload };
    },
    kycAddSigner(state, action) {
      const { payload } = action;

      return { ...state, addSignerData: payload };
    },
  },
});

export const { addSigner } = addSignerSlice.actions;
export default addSignerSlice.reducer;
